<template>
  <div
    class="pt-8 pb-4 text-center lg:pb-0 lg:text-left"
  >
    <h1 data-testid="page-title">{{ pageTitle }}</h1>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'PageTitle',
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
  },
});


</script>
